import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { CouponSearchDto } from './dto/coupon-search.dto';
import { CouponDto } from './dto/coupon.dto';

@Injectable({
  providedIn: 'root',
})
export class CouponService {
  constructor(private _apiService: ApiService) {}

  search(dto: CouponSearchDto): Promise<PagedResultGeneric<CouponDto>> {
    return this._apiService.post('Coupons/Search', dto);
  }

  update(dto: CouponDto): Promise<void> {
    return this._apiService.put(`Coupon/${dto.CouponId}`, dto);
  }

  delete(id: number): Promise<void> {
    return this._apiService.delete(`Coupon/${id}`);
  }
}
